export default __webpack_public_path__ + "static/media/shastasouthface-crop.132bc686.jpg";